import { Container, Row } from 'components/GridSystem';

import * as S from './styles';

export type FooterProps = {
  variant?: 'primary' | 'secondary' | 'third';
  showPolicyAndTerms?: boolean;
  className?: string;
};

const Footer = ({
  variant = 'primary',
  showPolicyAndTerms,
  className,
}: FooterProps) => {
  return (
    <S.Wrapper className={className} variant={variant}>
      <Container>
        <Row>
          <S.Col xs={12} sm={12}>
            {showPolicyAndTerms ? (
              <S.FooterLinkContainer>
                <S.FooterLink
                  href="https://savings.club/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy policy
                </S.FooterLink>
                <S.FooterLink
                  href="https://savings.club/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms
                </S.FooterLink>
              </S.FooterLinkContainer>
            ) : (
              variant !== 'third' && (
                <a aria-label="Savings Club Link" href="https://savings.club/">
                  <S.Logo variant={variant} />
                </a>
              )
            )}
            <S.CopyrightText variant={variant}>
              Copyright © {new Date().getFullYear()} Saving’s Club | All rights reserved.
            </S.CopyrightText>
          </S.Col>
        </Row>
      </Container>
    </S.Wrapper>
  );
};

export default Footer;
